import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/core/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class CrearPaqueteService {

  constructor(
    private api: ApiService
  ) {}

  crearPaquete(datos: any, _token: string) {
    return this.api.post<{ invoice: any }>(
      '/transactions/invoices/package/create',
      datos
    ).pipe(
      map((resp) => resp.invoice),
      catchError(e => {
        throw e;
      })
    );
  }

  crearFacturaConvenio(datos: any, _token: string) {
    return this.api.post(
      '/transactions/agreement-orders/invoice/create',
      datos
    ).pipe(
      catchError(e => {
        throw e;
      })
    );
  }
}
